
import App from './App.svelte'

const app = new App({
  target: document.getElementById('howlongnow')
})

export default app
